import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-commercial-imputations-to-validate',
  templateUrl: './dashboard-commercial-imputations-to-validate.component.html',
  styleUrls: ['./dashboard-commercial-imputations-to-validate.component.scss']
})
export class DashboardCommercialImputationsToValidateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
